export const setAvailableTime = (timerLock) => {
    return {
      type: 'SET_TIMERLOCK',
      payload: timerLock,
    };
  };
  
  export const clearAvailableTime = () => {
    return {
      type: 'CLEAR_TIMERLOCK',
    };
  };
  